import { Role, type User } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaUndo } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { useRole } from '../../hooks/useRole';
import { UserResetMfaModal } from './UserResetMfaModal';

interface Props {
  user: User;
}

export const UserResetMfaMenuItem = (props: Props) => {
  const { user } = props;
  const hasPermission = useRole(Role.Support);

  const onClick = () => {
    showModal(UserResetMfaModal, { user });
  };

  return (
    <ChakraV3.MenuItem value='reset-mfa' disabled={!hasPermission} onClick={onClick}>
      <FaUndo />
      Reset MFA
    </ChakraV3.MenuItem>
  );
};
